import { BETTERHELP_ONBOARDING_ROUTING_CONFIG } from '@uplift/constants';

import { SELF_PAY_ID } from '../../utils';
import {
  Eligibility, EligibilityGuard, BetterhelpOnboardingContextType, BetterhelpOnboardingMachineContext
} from '../types';

type BetterhelpOnboardingRoutingConfig = typeof BETTERHELP_ONBOARDING_ROUTING_CONFIG;
type Routes = BetterhelpOnboardingRoutingConfig[keyof BetterhelpOnboardingRoutingConfig];

export const syncRouteInvocation = (route: Routes, options?: { replace?: boolean }) => (({
  src: 'syncRouteActor',
  input: { route, replace: options?.replace }
}) as const);

export const getEligibility = (context: Partial<BetterhelpOnboardingMachineContext>): BetterhelpOnboardingContextType['eligibility'] => {
  const hasInsurance = context.insuranceId && context.insuranceId !== SELF_PAY_ID;

  const eligibility: Eligibility = {
    hasInsurance,
    isBookingSponsored: true,
  };

  return eligibility;
};

export const eligibilityGuard = (fn: EligibilityGuard<BetterhelpOnboardingMachineContext>, debug = true) => ({ context }) => {
  const eligibility = getEligibility(context);
  const res = fn(eligibility, context);

  if (debug) {
    console.log('eligibilityGuard', { fn, eligibility, context, res });
  }
  return res;
};

export const MATCHES_LOADING_DURATION = 3500;
